/**
 * ドライバー指示メモ
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/allocate/entries/manifests`

 const allocate_entry_manifest_driver_instruction = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    show ({ commit }, { manifest_id }) {
      const api_path = `${API_PATH}/${manifest_id}/driver_instructions`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    update ({ commit }, { manifest_id, params }) {
      const api_path = `${API_PATH}/${manifest_id}/driver_instructions`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params, { headers: { 'content-type': 'multipart/form-data'}}).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },

  },
  mutations: {},

 }

 export default allocate_entry_manifest_driver_instruction
